import { QueryClient } from '@tanstack/react-query'

// Shared with better-auth-ui's AuthProvider; cleared on sign-in/out so no stale session lingers.
export const queryClient = new QueryClient()
